import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  name: '',
  code: '',
  type: '',
  products: [],
  contacts: {
    type: '',
    ids: [],
    tags: []
  },
  experienceSettings: {
    messageParams: {
      senderName: '',
      message: '',
      aboutMessage: '',
      customizedRecipientMessages: {}
    },
    branding: {
      giftWrapperUrl: '',
      logoUrl: ''
    },
    sharingMethod: {
      params: { subject: '' }
    },
    occasion: ''
  },
  meta: {},
  settings: {},
  addons: []
};

let store = set => ({
  ...initialState,
  updateName: name => {
    set(() => ({
      name
    }));
  },
  updateType: type => {
    set(() => ({
      type
    }));
  },
  updateCode: code => {
    set(() => ({
      code
    }));
  },
  updateProducts: products => {
    set(() => ({
      products
    }));
  },
  updateContacts: contacts => {
    set(state => ({
      contacts: { ...state.contacts, ...contacts }
    }));
  },
  updateExperienceSettings: experienceSettings => {
    set(() => ({
      experienceSettings
    }));
  },
  onUpdateBranding: branding => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        branding: {
          ...experienceSettings.branding,
          ...branding
        }
      }
    }));
  },
  onUpdateOccasion: occasion => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        occasion
      }
    }));
  },
  onUpdateMessageParams: messageParams => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        messageParams: {
          ...experienceSettings.messageParams,
          ...messageParams
        }
      }
    }));
  },
  onUpdateSharingMethod: sharingMethod => {
    set(({ experienceSettings }) => ({
      experienceSettings: {
        ...experienceSettings,
        sharingMethod: {
          ...experienceSettings.sharingMethod,
          ...sharingMethod
        }
      }
    }));
  },
  updateSettings: newSettings => {
    set(({ settings }) => ({
      settings: { ...settings, ...newSettings }
    }));
  },
  updateMeta: meta => {
    set(() => ({
      meta
    }));
  },
  updateAddons: addons => {
    set(() => ({
      addons
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'newAutomation',
  storage: createJSONStorage(() => sessionStorage)
});
export const useNewAutomationStore = create(devtools(store));
